import { Component, inject } from '@angular/core';
import { MenuItemService, ThemeService } from '../../services';
import { NavLinksComponent } from './nav-links.component';
import { SidenavWrapperComponent } from './sidenav-wrapper.component';

@Component({
  selector: 'lib-navigation',
  standalone: true,
  imports: [
    SidenavWrapperComponent,
    NavLinksComponent
  ],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss'
})
export class NavigationComponent {
  private readonly themeService = inject(ThemeService);
  private readonly menuService = inject(MenuItemService);

  navGroups = this.menuService.mobileMenuItems;

  closeSideNav() {
    this.themeService.closeSideNav();
  }
}
